

























































/* eslint-disable @typescript-eslint/camelcase */
import { inject } from 'inversify-props'
import API from '@core/services/API'
import { Component, Vue } from 'vue-property-decorator'
import AppDatatable from '@core/components/AppDatatable.vue'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import { isUndefined } from 'lodash/fp'
import { IDateService } from '@master/services/IDateService'
import { BscRecordMeta, SupervisorGradeMeta } from '@core/model/common/BscRecordMeta'
import AppDialog from '@core/components/AppDialog.vue'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'
import { getBscGradeInText } from '@master/config/bsc-grade'

@Component({
  components: {
    AppDatatable,
    AppForm,
    AppDialog
  }
})
export default class UserBscRecords extends Vue {
  @inject()
  private $api: API

  @inject()
  private dateService: IDateService

   uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  private bscRecordList: BscRecordMeta[] = []
  private isModalVisible = false
  private isEditMode = false
  private prevBscRecordList: BscRecordMeta[] = []
  private newPrevBscRecord: BscRecordMeta = new BscRecordMeta()
  private supervisorGradeRecords: SupervisorGradeMeta[] = []

  get bscRecordRows () {
    return this.bscRecordList.map(e => {
      return {
        ...e,
        dateCompleted: this.dateService.format(e.dateCompleted, 'YYYY-MM-DD'),
        redirect: `/live/user-bsc-record/${this.userOid}/${e.oid}`
      }
    })
  }

  async bscRecordRowClicked (row: BscRecordMeta) {
    await this.$router.push({ name: 'User BSC Records', params: { bscOid: row.oid, userOid: this.userOid } })
  }

  get supervisorGradeColumns (): Array<{ label: string; field: keyof SupervisorGradeMeta }> {
    return [
      { label: 'Review Year', field: 'reviewYear' },
      { label: 'Quarter', field: 'reviewQuarter' },
      { label: 'Grade', field: 'bscGrade' }
    ]
  }

  get bscRecordColumns (): Array<{ label: string; field: keyof BscRecordMeta }> {
    return [
      { label: 'Review Year', field: 'reviewYear' },
      { label: 'Quarter', field: 'reviewQuarter' },
      { label: 'Grade', field: 'bscGrade' },
      { label: 'ISAU Reviewer', field: 'isauReviewer' },
      { label: 'Date Completed', field: 'dateCompleted' },
      { label: 'No of Cat 1 Infractions', field: 'cat1InfractionTotal' },
      { label: 'No of Cat 2 Infractions', field: 'cat2InfractionTotal' },
      { label: 'No of Administrative Errors', field: 'adminErrorTotal' }
    ]
  }

  get prevBscRecordRows () {
    return this.prevBscRecordList.map(e => {
      return {
        ...e,
        dateCompleted: this.dateService.format(e.dateCompleted, 'YYYY-MM-DD'),
        emit: true
      }
    })
  }

  get prevBscRecordColumns (): Array<{ label: string; field: keyof BscRecordMeta }> {
    return [
      { label: 'Company', field: 'company' },
      { label: 'Review Year', field: 'reviewYear' },
      { label: 'Quarter', field: 'reviewQuarter' },
      { label: 'Grade', field: 'bscGrade' },
      { label: 'ISAU Reviewer', field: 'isauReviewer' },
      { label: 'Date Completed', field: 'dateCompleted' },
      { label: 'No of Cat 1 Infractions', field: 'cat1InfractionTotal' },
      { label: 'No of Cat 2 Infractions', field: 'cat2InfractionTotal' },
      { label: 'No of Administrative Errors', field: 'adminErrorTotal' }
    ]
  }

  get isButtonVisible () {
    return this.currentUser.systemrole === 'bsc-reviewer' || this.currentUser.systemrole === 'ops-staff'
  }

  get currentUser () {
    return this.$store.getters.currentUser
  }

  get userOid (): string {
    return this.$route.params.userOid as string || this.$store.getters.currentUser.accountID
  }

  get isSuperUser () {
    return this.$store.getters.currentUser.isSuperUser
  }

  get isOpsStaff () {
    return this.currentUser.systemrole === 'ops-staff'
  }

  get isBscReviewer () {
    return this.currentUser.systemrole === 'bsc-reviewer'
  }

  renameObjectKeys (list: Array<object>, keys: Array<string>): Array<object> {
    const newList = list.map(function (data) {
      const keyValues = Object.keys(data).map(function (key) {
        const newKey = keys[key]
        return { [newKey]: data[key] }
      })
      return Object.assign({}, ...keyValues)
    })
    return newList
  }

  async getBscRecordList () {
    const headers = [
      '_oid',
      'review_oid',
      'user_oid',
      'review_year',
      'review_quarter',
      'bsc_grade',
      'isau_reviewer',
      'date_completed',
      'cat_1_infraction_total',
      'cat_2_infraction_total',
      'admin_error_total'
    ]

    const res = await this.$api.bscRecords.listReviewMeta({
      query: 'user_oid = ?',
      queryArgs: JSON.stringify([this.userOid]),
      headers: JSON.stringify(headers)
    })

    this.bscRecordList = res.data.map(e => {
      const bscRecord = new BscRecordMeta()
      bscRecord.assignData(headers, e)
      return bscRecord
    })
  }

  async getPrevBscRecordList () {
    const res = await this.$api.bscRecords.listPrev({
      _oid: this.userOid
    })
    this.prevBscRecordList = res.data.map(e => {
      const prevBscRec = new BscRecordMeta()
      prevBscRec.assignData(Object.keys(e), Object.values(e))
      return prevBscRec
    })
  }

  async getSupervisorGradingRecord () {
    const data = await this.$api.bsc.supervisorReview.getDetails(this.userOid) || []
    this.supervisorGradeRecords = data.map(supervisor => {
      return {
        reviewYear: supervisor.reviewYear,
        reviewQuarter: supervisor.reviewQuarter,
        bscGrade: getBscGradeInText(supervisor.bscGrade)
      }
    })
  }

  openModal (data?: BscRecordMeta): void {
    this.isModalVisible = true
    this.isEditMode = false
    this.newPrevBscRecord = new BscRecordMeta()
    if (!isUndefined(data)) {
      this.isEditMode = true
      this.newPrevBscRecord = data
    }
  }

  get prevBscRecordStructure (): FormStructure<BscRecordMeta> {
    return [
      {
        label: 'Name of Company',
        key: 'company',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Review Year',
        key: 'reviewYear',
        type: 'number',
        disabled: !this.isOpsStaff
      },
      {
        label: 'BSC Quarter',
        key: 'reviewQuarter',
        type: 'number',
        disabled: !this.isOpsStaff
      },
      {
        label: 'BSC Grade',
        key: 'bscGrade',
        disabled: !this.isOpsStaff
      },
      {
        label: 'ISAU Reviewer',
        key: 'isauReviewer',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Date Completed',
        key: 'dateCompleted',
        type: 'date',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Total Cat 1 Infractions',
        key: 'cat1InfractionTotal',
        type: 'number',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Total Cat 2 Infractions',
        key: 'cat2InfractionTotal',
        type: 'number',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Total Administrative Errors',
        key: 'adminErrorTotal',
        type: 'number',
        disabled: !this.isOpsStaff
      }
    ]
  }

  rowClickPrevBscRecord (row: BscRecordMeta): void {
    this.openModal(row)
  }

  async updatePrevBscRecord () {
    await this.$api.bscRecords.update({
      previous_record_oid: this.newPrevBscRecord.previousRecordOid,
      data: JSON.stringify(this.newPrevBscRecord.convertToRawData())
    })
    this.isModalVisible = false
    await this.getPrevBscRecordList()
  }

  async savePrevBscRecord () {
    await this.$api.bscRecords.new({
      _oid: this.userOid,
      data: JSON.stringify(this.newPrevBscRecord.convertToRawData())
    })
    this.isModalVisible = false
    await this.getPrevBscRecordList()
  }

  async created () {
    this.uiService = this.sharedVariable.uiService
    await this.getBscRecordList()
    await this.getPrevBscRecordList()
    if (this.isBscReviewer || this.isOpsStaff) {
      await this.getSupervisorGradingRecord()
    }
  }
}
